import { Routes } from "./Routes";

export const DefaultRoutesAccessLevel = new Map([
    [1, Routes.Calendar],
    [2, Routes.Calendar],
    [3, Routes.Blocks],
    [4, Routes.Demos],
    [5, Routes.Showrooms],
]);